<div class="header">
  <div class="title">Merge into Portfolio</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
@if (portfolios$ | async; as portfolios) {
  @if ((ui | async).merging) {
    <div class="merging-panel">
      <mat-spinner></mat-spinner>
      <div class="merging-panel__progress">
        @for (message of progressMessages | async; track message) {
          <p class="animate__animated animate__slideInDown animate__faster">
            @if (message === 'An error occurred') {
              <ts-icon icon="ts_close" class="red-error"></ts-icon> {{ message }}
            } @else if (message === 'Complete') {
              <ts-icon icon="check_circle" class="green-success"></ts-icon> {{ message }}
            } @else {
              <ts-icon icon="merge_type"></ts-icon> {{ message }}
            }
          </p>
        }
      </div>
    </div>
  } @else {
    <form [formGroup]="form">
      <mat-form-field class="hidden-borders">
        <mat-label>Portfolio merge mode</mat-label>
        <input matInput class="hidden" type="text" />
        <mat-radio-group formControlName="merge_mode">
          <mat-radio-button value="new" class="mr-4">Merge into a new Portfolio</mat-radio-button>
          <mat-radio-button value="existing" [disabled]="!portfolios.length"
            >Merge into an existing Portfolio</mat-radio-button
          >
        </mat-radio-group>
      </mat-form-field>
      @if (form.get('merge_mode').value === 'existing') {
        <mat-form-field>
          <mat-label>Choose a Portfolio</mat-label>
          <mat-select formControlName="destination_portfolio_id">
            @for (portfolio of portfolios; track portfolio) {
              <mat-option [value]="portfolio.id"> {{ portfolio.title }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (form.get('merge_mode').value === 'new') {
        <mat-form-field>
          <mat-label>New Portfolio name</mat-label>
          <input matInput type="text" formControlName="destination_portfolio_name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Template</mat-label>
          <mat-select formControlName="destination_portfolio_layout_id">
            @for (template of data.templates; track template) {
              <mat-option [value]="template.id"> {{ template.name }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>View</mat-label>
          <mat-select formControlName="destination_portfolio_pipeline_id">
            @for (pipeline of data.pipelines; track pipeline) {
              <mat-option [value]="pipeline.id"> {{ pipeline.name }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if ((ui | async).preview) {
        <div class="new-structure-preview">
          <p class="new-structure-preview__parent">{{ previewData.portfolioName }}</p>
          <p></p>
          @for (child of previewData.children; track child) {
            <p class="new-structure-preview__child">
              <mat-icon svgIcon="subdirectory_arrow_right"></mat-icon> {{ child }}
            </p>
          }
        </div>
      }
      <div class="buttons">
        <ts-button type="flat" color="basic" (click)="discard()">Cancel</ts-button>
        @if ((ui | async).preview) {
          <ts-button [loading]="(ui | async).loading" type="flat" (click)="createPortfolio(true)">Merge</ts-button>
        } @else {
          <ts-button [loading]="(ui | async).loading" [disabled]="!form.valid" type="flat" (click)="createPortfolio()"
            >Validate</ts-button
          >
        }
      </div>
    </form>
  }
} @else {
  <div class="flex flex-col w-full gap-2">
    <ts-skeleton />
    <ts-skeleton />
    <ts-skeleton />
    <ts-skeleton />
  </div>
}
